import React from 'react';
import { string, oneOfType, arrayOf, node } from 'prop-types';
import classnames from 'classnames';
import './Card.scss';

import './Card.scss';

const Card = React.forwardRef(({ className, children, ...otherProps }, ref) => {
    const rootClassnames = classnames(className, 'card-root');
    return (
        // ref={ref} is mandatory for tooltip component
        <div ref={ref} className={rootClassnames} {...otherProps}>
            {children}
        </div>
    );
});

Card.displayName = 'Card';

Card.propTypes = {
    className: string,
    children: oneOfType([node, arrayOf(node)]).isRequired,
};

Card.defaultProps = {
    className: '',
};

export default Card;
